// Priority interface error text ({ FORM: { InterfaceErrors: { text } } }),
// without its "שורה N-" line prefix; falls back to `fallback` otherwise.
export const cleanFormError = (response, fallback) =>
  response?.data?.FORM?.InterfaceErrors?.text?.replace(/^.*?\d+\s*-\s*/, "") ||
  fallback;
